import React from 'react';
import { useCases } from '../data/content';
import { BallMark, CourtMark, GoalMark } from './icons/HandballMarks';
const marks = [GoalMark, CourtMark, BallMark];
export function UseCases() {
  return <section className="bg-slate-100 px-5 py-16 sm:py-20" data-id="element-219" data-mp="35gf7m7pcqqen">
      <div className="mx-auto max-w-5xl" data-id="element-220" data-mp="35eubidne2zeo">
        <div className="mx-auto max-w-2xl text-center" data-id="element-221" data-mp="31get6n296f7l">
          <h2 className="font-display text-3xl font-black leading-tight text-navy-800 sm:text-4xl" data-id="element-222" data-mp="31dslmnfd3zpd">
            Einsatzbereiche
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-slate-600 sm:text-base" data-id="element-223" data-mp="2rh60dxj4j6mt">
            Die Sammlung ist für die Planung von Kinderhandball im Verein und im
            Schulsport angelegt.
          </p>
        </div>

        <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-224" data-mp="2iic09x6l3y4i">
          {useCases.map((item, index) => {
          const Mark = marks[index] ?? BallMark;
          return <article key={item.title} className="flex h-full flex-col rounded-xl border-t-4 border-gold bg-white p-6 shadow-sm" data-id="element-225" data-mp="gqfnylclek8o" data-mpi={index}>
                <Mark className="h-8 w-auto text-navy-800" data-id="element-226" data-mp="2wttptt3ipla1" />
                <h3 className="mt-5 font-display text-lg font-extrabold text-navy-800" data-id="element-227" data-mp="2wr7jtxw9zdtx">
                  {item.title}
                </h3>
                <p className="mt-auto pt-3 text-sm leading-relaxed text-slate-600" data-id="element-228" data-mp="2mukzrbbrwqsy">
                  {item.description}
                </p>
              </article>;
        })}
        </div>
      </div>
    </section>;
}